import { render, staticRenderFns } from "./noticeOnline.vue?vue&type=template&id=42987966&scoped=true&"
import script from "./noticeOnline.vue?vue&type=script&lang=js&"
export * from "./noticeOnline.vue?vue&type=script&lang=js&"
import style0 from "./noticeOnline.vue?vue&type=style&index=0&id=42987966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42987966",
  null
  
)

export default component.exports